let $ = jQuery;

class Breakpoints {

  constructor() {
    this._current = null;

    $(window).resize(() => this.refreshValue()).trigger('resize');
  }

  refreshValue() {
    this._current = window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content').replace(/\"/g, '');
  }

  get current() {
    return this._current;
  }

}

let breakpoints = new Breakpoints();

module.exports = breakpoints;
